<template>
  <div>
    <b-row>
      <b-container class="content">
        <b-overlay :show="showOverlay" rounded="sm">
          <SearchForm :params="model.params" :results="model.results" @search="onSearch"/>
        </b-overlay>
        <b-row class="mt-5" v-if="results.length">
          <b-col sm="12"><hr /></b-col>
          <b-col sm="12">
            <BookingResults
              :results="model.results"
              @view="onView"
              @editPassenger="editPassenger"/>
            </b-col>
        </b-row>
      </b-container>
    </b-row>
    <b-modal v-model="modal" title="Modal Info" size="xl" no-close-on-backdrop hide-header hide-footer>
      <SimpleModalHeader  @closeModal="close" />
      <EditPassenger :bookingId="currentBooking" @closeModal="close" />
    </b-modal>
  </div>
</template>

<script>
import model from './services/model'

import SearchForm from './components/search_form'
import BookingResults from './components/booking_results'
import SimpleModalHeader from '@/app/private/shared/components/simple_modal_header'
import EditPassenger from './components/edit_passenger'

export default {
  name: 'BookingSearch',
  components: { SearchForm, BookingResults, SimpleModalHeader, EditPassenger },
  data () {
    return {
      model,
      showOverlay: false,
      modal: false,
      currentBooking: null
    }
  },
  computed: {
    results () {
      return model.results
    }
  },
  methods: {
    onSearch (params) {
      this.showOverlay = true
      model.search(params)
        .finally(() => { this.showOverlay = false })
    },
    onView (id) {
      this.$router.push({
        name: 'Private/Bookings/View',
        params: {
          Id: id
        }
      })
    },
    editPassenger (id) {
      this.currentBooking = id
      this.modal = true
    },
    close () {
      this.modal = false
    }
  }
}
</script>

<style scoped>

</style>
